var customVideoListCount;
    var customVideoListDefaultLeft;

    $(document).ready(function() {

        var before = "before";
        var after = "after";
        var customVideoDiv = 'customVideoDiv';
        var parentClassName= 'customVideoListMoveDiv';

        customVideoListCount = $('.customVideoListMoveDiv').children('.customVideoDiv').length;

        if ( customVideoListCount > 6 ){
            // 复制前六个到最后
            var copyDiv1 = copyDivByClassName(0,"customVideoDiv-" + (parseInt(customVideoListCount) + 1),(parseInt(customVideoListCount) + 1),customVideoDiv);
            copyDiv1.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 1));
            var copyDiv2 = copyDivByClassName(1,"customVideoDiv-" + (parseInt(customVideoListCount) + 2),(parseInt(customVideoListCount) + 2),customVideoDiv);
            copyDiv2.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 2));
            var copyDiv3 = copyDivByClassName(2,"customVideoDiv-" + (parseInt(customVideoListCount) + 3),(parseInt(customVideoListCount) + 3),customVideoDiv);
            copyDiv3.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 3));
            var copyDiv4 = copyDivByClassName(3,"customVideoDiv-" + (parseInt(customVideoListCount) + 4),(parseInt(customVideoListCount) + 4),customVideoDiv);
            copyDiv4.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 4));
            var copyDiv5 = copyDivByClassName(4,"customVideoDiv-" + (parseInt(customVideoListCount) + 5),(parseInt(customVideoListCount) + 5),customVideoDiv);
            copyDiv5.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 5));
            var copyDiv6 = copyDivByClassName(5,"customVideoDiv-" + (parseInt(customVideoListCount) + 6),(parseInt(customVideoListCount) + 6),customVideoDiv);
            copyDiv6.children('.textDiv').attr('id','customVideoDivText-'+(parseInt(customVideoListCount) + 6));

            // 复制最后六个到最前
            var copyDiv7 = copyDivByClassName(customVideoListCount-1,"customVideoDiv-" + 0,0,customVideoDiv);
            copyDiv7.children('.textDiv').attr('id','customVideoDivText-'+0);
            var copyDiv8 = copyDivByClassName(customVideoListCount-2,"customVideoDiv-" + "-1",-1,customVideoDiv);
            copyDiv8.children('.textDiv').attr('id','customVideoDivText--1');
            var copyDiv9 = copyDivByClassName(customVideoListCount-3,"customVideoDiv-" + "-2",-2,customVideoDiv);
            copyDiv9.children('.textDiv').attr('id','customVideoDivText--2');
            var copyDiv10 = copyDivByClassName(customVideoListCount-4,"customVideoDiv-" + "-3",-3,customVideoDiv);
            copyDiv10.children('.textDiv').attr('id','customVideoDivText--3');
            var copyDiv11 = copyDivByClassName(customVideoListCount-5,"customVideoDiv-" + "-4",-4,customVideoDiv);
            copyDiv11.children('.textDiv').attr('id','customVideoDivText--4');
            var copyDiv12 = copyDivByClassName(customVideoListCount-6,"customVideoDiv-" + "-5",-5,customVideoDiv);
            copyDiv12.children('.textDiv').attr('id','customVideoDivText--5');

            // 粘贴
            // 前
            appendDivByClassName(before,parentClassName,copyDiv1);
            appendDivByClassName(before,parentClassName,copyDiv2);
            appendDivByClassName(before,parentClassName,copyDiv3);
            appendDivByClassName(before,parentClassName,copyDiv4);
            appendDivByClassName(before,parentClassName,copyDiv5);
            appendDivByClassName(before,parentClassName,copyDiv6);

            // 后
            appendDivByClassName(after,parentClassName,copyDiv7);
            appendDivByClassName(after,parentClassName,copyDiv8);
            appendDivByClassName(after,parentClassName,copyDiv9);
            appendDivByClassName(after,parentClassName,copyDiv10);
            appendDivByClassName(after,parentClassName,copyDiv11);
            appendDivByClassName(after,parentClassName,copyDiv12);

            customVideoListDefaultLeft = $(".customVideoListDiv").outerWidth() * -1;
            $(".customVideoListMoveDiv").css('left',customVideoListDefaultLeft);

            var customVideoDivWidth = $('.customVideoDiv').outerWidth(true);
            customVideoListMoveDiv.css('left',6 * customVideoDivWidth * -1);
        }
    })



    //===========点击设置视频链接===============
    var customVideoListClickHref;

    $(".video-close").click(function() {
        $(".videoPopupShowDiv").hide();
        $(".customVideoListYoutubeVideo").remove();
    })

    //================鼠标经过==========================
    $(".customVideoDiv").hover(function (){
        var index = $(this).data('index');
        $("#customVideoDivText-"+index).fadeOut(200);
    },function (){
        var index = $(this).data('index');
        $("#customVideoDivText-"+index).fadeIn(200);
    })

    //==================箭头移动==========================
    // 基础参数
    var customVideoListMoveDiv = $('.customVideoListMoveDiv');
    var customVideoDivWidth = $('.customVideoDiv').outerWidth(true);
    var currentCustomVideoIndex = 1;
    var currentCustomVideoAnimateFlag = false;

    // 监听修改页面大小
    $(window).resize(function() {
        customVideoDivWidth = $('.customVideoDiv').outerWidth(true);
        customVideoListMoveDiv.css('left',6 * customVideoDivWidth * -1);
    });

    function  customVideoListMoveNext() {

        // 判断是否还在动画
        if (currentCustomVideoAnimateFlag || customVideoListCount<= 6){
            return;
        }
        currentCustomVideoAnimateFlag = true;

        currentCustomVideoIndex++;

        customVideoListMoveDiv.stop().animate({left:'-=' + customVideoDivWidth + 'px' }, 500, function() {

            if (currentCustomVideoIndex >= customVideoListCount + 1){
                currentCustomVideoIndex = 1;
                customVideoListMoveDiv.css('left',6 * customVideoDivWidth * -1);
            }
            currentCustomVideoAnimateFlag = false;
        });

    }

    function customVideoListMovePrevious() {

        if (currentCustomVideoAnimateFlag || customVideoListCount<= 6){
            return;
        }
        currentCustomVideoAnimateFlag = true;

        currentCustomVideoIndex--;


        customVideoListMoveDiv.stop().animate({left:'+=' + customVideoDivWidth + 'px' }, 500, function() {

            if (currentCustomVideoIndex <= -5){
                currentCustomVideoIndex = parseInt(customVideoListCount) - 5;
                customVideoListMoveDiv.css('left','calc(' + (currentCustomVideoIndex - 1) * customVideoDivWidth * -1 + 'px - '+customVideoListDefaultLeft * -1+'px)' );
            }
            currentCustomVideoAnimateFlag = false;
        });
    }

    /*=================== 拖拽 =================== */
    var customVideoListIsKeyDown = false;
    var customVideoListMoveX = 0;
    var customVideoListCurrentX;
    var customVideoListTriggerMoveX;
    var customVideoListTriggerCurrentX;

    // 监听按下
    customVideoListMoveDiv.on('touchstart mousedown',function (e) {

        if (customVideoListCount > 6){
            customVideoListIsKeyDown = true;
            if (e.type == 'mousedown'){
                customVideoListCurrentX = e.clientX;
                customVideoListTriggerCurrentX = e.clientX;
            }else if (e.type == 'touchstart'){
                customVideoListCurrentX = e.originalEvent.changedTouches[0].clientX;
                customVideoListTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
            }
        }

    });

    function customVideoDivMouseDown(e,url){

        customVideoListClickHref = url;
        customVideoListIsKeyDown = true;
        if (customVideoListCount > 6){
            if (e.type == 'mousedown'){
                customVideoListCurrentX = e.clientX;
                customVideoListTriggerCurrentX = e.clientX;
            }else if (e.type == 'touchstart'){
                customVideoListCurrentX = e.originalEvent.changedTouches[0].clientX;
                customVideoListTriggerCurrentX = e.originalEvent.changedTouches[0].clientX;
            }
        }
    }

    // 监听鼠标移动事件
    customVideoListMoveDiv.on('touchmove mousemove',function (e) {
        if (customVideoListCount > 6){

            if (customVideoListIsKeyDown) {
                // 计算移动距离
                if (e.type == 'mousemove'){
                    customVideoListMoveX = parseInt(e.clientX) -  parseInt(customVideoListCurrentX);
                    customVideoListTriggerMoveX =  parseInt(e.clientX) -  parseInt(customVideoListTriggerCurrentX);
                }else if (e.type == 'touchmove'){
                    customVideoListMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(customVideoListCurrentX);
                    customVideoListTriggerMoveX = parseInt(e.originalEvent.changedTouches[0].clientX) - parseInt(customVideoListTriggerCurrentX);
                }
                if (customVideoListMoveX == 0 || customVideoListTriggerMoveX == 0) {
                    return;
                }
                if (customVideoListMoveX > 0){
                    customVideoListMoveDiv.stop().animate({left: "+=" + customVideoListTriggerMoveX * 1.15  + "px"}, 0, function() {

                    });
                }else if(customVideoListMoveX < 0){
                    customVideoListMoveDiv.stop().animate({left: "+=" + customVideoListTriggerMoveX * 1.15 + "px"}, 0, function() {

                    });
                }
                // 重要！ 准确记录每次触发的移动量
                customVideoListTriggerCurrentX = e.clientX;
            }
        }


    })

    // 监听抬起
    customVideoListMoveDiv.on('touchend mouseup',function (e) {

        if (customVideoListCount > 6 && customVideoListIsKeyDown){

            customVideoListIsKeyDown = false;

            if (customVideoListMoveX == 0) {

                var videoHtml = '<iframe width="100%" height="100%" src="' + customVideoListClickHref + '" class="youtube-player youtubeVideo  customVideoListYoutubeVideo" frameborder="0"></iframe>';

                $(".youtubeVideoDiv").prepend(videoHtml);
                $(".videoPopupShowDiv").show();

                return;
            }

            var maxLeft =(customVideoListCount + 6) * customVideoDivWidth;
            customVideoListMoveX = customVideoListMoveX * 1.15;


            // 超出的距离（余数）
            var moveCount =Math.round(Math.abs(parseInt(customVideoListMoveX)) / parseInt(customVideoDivWidth));
            var overX =Math.abs(parseInt(customVideoListMoveX)) % parseInt(customVideoDivWidth);
            var currentLeft = customVideoListMoveDiv.css('left');

            if (overX > (customVideoDivWidth / 2)){

                if ((parseInt(currentLeft) + customVideoListMoveX + overX ) * -1 > maxLeft){
                    var last = ((customVideoListCount + 6) * customVideoDivWidth * -1);
                    customVideoListMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * customVideoDivWidth) ) > 0){
                    customVideoListMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else {
                    if (customVideoListMoveX > 0){
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex - moveCount  + 5) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;
                        });
                    }else {
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex + moveCount + 5 ) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;
                        });
                    }

                }

            }else{
                // 反之
                if ((parseInt(currentLeft) + customVideoListMoveX ) * -1 > maxLeft){
                    var last = ((customVideoListCount + 6) * customVideoDivWidth * -1);
                    customVideoListMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * customVideoDivWidth) ) > 0){
                    customVideoListMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else{
                    if (customVideoListMoveX > 0){
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex - moveCount  + 5) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;

                        });
                    }else {
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex + moveCount + 5 ) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;

                        });
                    }
                }

            }
            // 重置位移数，防止连点移动
            customVideoListMoveX = 0;

            sleep(350).then(() => {

                currentCustomVideoIndex = Math.floor(parseInt(customVideoListMoveDiv.css('left')) * -1 / parseInt(customVideoDivWidth)) - 5;

                if (currentCustomVideoIndex <= -5){
                    currentCustomVideoIndex = parseInt(customVideoListCount) - 5;
                    customVideoListMoveDiv.css('left','calc(' + (currentCustomVideoIndex - 1) * customVideoDivWidth * -1 + 'px - '+(customVideoListDefaultLeft * -1)+'px)' );
                }

                if (currentCustomVideoIndex >= customVideoListCount + 1){
                    currentCustomVideoIndex = 1;
                    customVideoListMoveDiv.css('left',6 * customVideoDivWidth * -1);
                }

            })


        }
        else if (customVideoListCount <= 6 && customVideoListIsKeyDown){
            if (customVideoListMoveX == 0) {

                var videoHtml = '<iframe width="100%" height="100%" src="' + customVideoListClickHref + '" class="youtube-player youtubeVideo  customVideoListYoutubeVideo" frameborder="0"></iframe>';

                $(".youtubeVideoDiv").prepend(videoHtml);
                $(".videoPopupShowDiv").show();

                return;
            }
        }

    });

    customVideoListMoveDiv.hover(function (){

    },function (){

        if (customVideoListCount > 6 && customVideoListIsKeyDown){

            customVideoListIsKeyDown = false;

            if (customVideoListMoveX == 0) {
                return;
            }

            var maxLeft =(customVideoListCount + 6) * customVideoDivWidth;
            customVideoListMoveX = customVideoListMoveX * 1.15;


            // 超出的距离（余数）
            var moveCount =Math.round(Math.abs(parseInt(customVideoListMoveX)) / parseInt(customVideoDivWidth));
            var overX =Math.abs(parseInt(customVideoListMoveX)) % parseInt(customVideoDivWidth);
            var currentLeft = customVideoListMoveDiv.css('left');

            if (overX > (customVideoDivWidth / 2)){

                if ((parseInt(currentLeft) + customVideoListMoveX + overX ) * -1 > maxLeft){
                    var last = ((customVideoListCount + 6) * customVideoDivWidth * -1);
                    customVideoListMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * customVideoDivWidth) ) > 0){
                    customVideoListMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else {
                    if (customVideoListMoveX > 0){
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex - moveCount  + 5) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;
                        });
                    }else {
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex + moveCount + 5 ) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;
                        });
                    }

                }

            }else{
                // 反之
                if ((parseInt(currentLeft) + customVideoListMoveX ) * -1 > maxLeft){
                    var last = ((customVideoListCount + 6) * customVideoDivWidth * -1);
                    customVideoListMoveDiv.stop().animate({left: last + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else if ((parseInt(currentLeft) + (moveCount * customVideoDivWidth)) > 0){
                    customVideoListMoveDiv.stop().animate({left: 0 + 'px' }, 300, function() {
                        currentCustomVideoAnimateFlag = false;
                    });
                }else{
                    if (customVideoListMoveX > 0){
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex - moveCount  + 5) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;

                        });
                    }else {
                        customVideoListMoveDiv.stop().animate({left: (currentCustomVideoIndex + moveCount + 5 ) * customVideoDivWidth * -1 + 'px' }, 300, function() {
                            currentCustomVideoAnimateFlag = false;

                        });
                    }
                }

            }
            // 重置位移数，防止连点移动
            customVideoListMoveX = 0;

            sleep(350).then(() => {

                currentCustomVideoIndex = Math.floor(parseInt(customVideoListMoveDiv.css('left')) * -1 / parseInt(customVideoDivWidth)) - 5;

                if (currentCustomVideoIndex <= -5){
                    currentCustomVideoIndex = parseInt(customVideoListCount) - 5;
                    customVideoListMoveDiv.css('left','calc(' + (currentCustomVideoIndex - 1) * customVideoDivWidth * -1 + 'px - '+(customVideoListDefaultLeft * -1)+'px)' );
                }

                if (currentCustomVideoIndex >= customVideoListCount + 1){
                    currentCustomVideoIndex = 1;
                    customVideoListMoveDiv.css('left',6 * customVideoDivWidth * -1);
                }

            })


        }
    })
